<script>
/* eslint-disable */
import axios from "axios";

import Assistant from "@/components/Assistant";
import Popup_success from "@/components/Popup_success";

export default {
	name: "Home",
	data() {
		return {
			isActiveAssistant: false,
			isActiveSuccess: false,
			isActiveCondition: false,
			isActiveConditionOpen: [false, false, false, false, false, false, false, false, false],
			isShowTag: false,
			isShowAssistantBtn: false,
			searchResult: [], //搜尋結果
			allSearchConditions: {}, //api取得之所有搜尋條件
			sortValue: "", //排序方式
			searchConditions: {}, //使用者選擇之條件
			aliasDealerArr: [],
			defaultSearchConditions: {
				authtype: [],
				series: [],
				model: [],
				power: [],
				color: [],
				low_price: "",
				high_price: "",
				near_factory: "",
				far_factory: "",
				low_mileage: "",
				high_mileage: "",
				dealer: [],
			}, //使用者選擇之條件預設值
			searchTag: {}, //搜尋標籤
			defaultSearchTag: {
				series: [],
				authtype: [],
				model: [],
				power: [],
				color: [],
				dealer: [],
				low_price: "",
				high_price: "",
				low_mileage: "",
				high_mileage: "",
				near_factory: "",
				far_factory: "",
				isSearch: false, //判斷是否顯示清除篩選條件按鈕
				totalCount: 0, //搜尋結果之車款數量
			}, //搜尋標籤之預設值
			isEnterWithDealer: false,
			scrollPosition: 0,
		};
	},
	computed: {
		hostUrl() {
			return this.$store.state.hostUrl;
		},
		fileHostUrl() {
			return this.$store.state.fileHostUrl;
		},
	},
	components: {
		Assistant,
		Popup_success,
	},
	created() {
		const _this = this;

		_this.resetSearchConditions();
	},
	activated() {
		const _this = this;
		_this.$nextTick(() => {
			if (_this.$route.query.dealer) {
				_this.aliasDealerArr = [];
				_this.aliasDealerArr = _this.$route.query.dealer.split(",");
			}

			if (_this.searchResult.length === 0) {
				_this.searchInit();
			} else {
				setTimeout(() => {
					_this.$emit("update:isActiveLoading", false);
				}, 1000);
			}
		});
	},
	beforeRouteLeave(to, from, next) {
		// console.log("beforeRouteLeave")
		this.$emit("update:isActiveLoading", true);
		if (document.getElementsByClassName("home")) {
			const _this = this;
			_this.scrollPosition = window.scrollY;
		}
		next();
	},
	beforeRouteEnter(to, from, next) {
		next((_this) => {
			if (from.name === "Info" && _this.scrollPosition !== 0) {
				_this.$nextTick(() => {
					window.scrollTo(0, _this.scrollPosition);
				});
			}
		});
	},
	methods: {
		//取得所有條件狀態
		searchInit(formData) {
			// console.log("searchInit");
			const _this = this;

			axios
				.post("/secondhand/searchInit", formData ? formData : "")
				.then((response) => {
					if (response.status === 200) {
						// console.log(response.data);
						_this.allSearchConditions = response.data;

						if (!_this.isEnterWithDealer && _this.$route.query.dealer) {
							_this.isEnterWithDealer = true;
							for (let i = 0; i < _this.aliasDealerArr.length; i++) {
								for (let j = 0; j < _this.allSearchConditions.dealer.length; j++) {
									if (
										_this.allSearchConditions.dealer[j].alias ===
										_this.aliasDealerArr[i]
									) {
										_this.searchConditions.dealer.push(
											_this.allSearchConditions.dealer[j].value,
										);
									}
								}
							}
							_this.onConditionsChange();
						} else {
							_this.search();
						}
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		//取得符合條件之車款
		search() {
			// console.log("search");
			const _this = this;

			_this.resetSearchTag();
			_this.searchTagAdd();

			_this.isShowAssistantBtn = false;

			const formData = new FormData();
			for (var key in _this.searchConditions) {
				formData.append(key, _this.searchConditions[key]);
			}

			axios
				.post("/secondhand/search", formData)
				.then((response) => {
					if (response.status === 200) {
						// console.log(response.data);
						if (response.data.length === 0) {
							_this.isShowAssistantBtn = true;
						}
						_this.$set(_this.searchTag, "totalCount", response.data.length);

						response.data.forEach((element) => {
							_this.searchResult.push(element);
						});

						_this.onsortChange(_this.sortValue);
						_this.$nextTick(() => {
							setTimeout(() => {
								_this.$emit("update:isActiveLoading", false);
								arphicWebFontApi.loadWebFont([
									{
										selectorName: ".font", // 指定元素
										fontName: "文鼎標準宋體_B", // 設定中文字型名稱
									},
								]);
							}, 1000);
						});
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 新增篩選條件之標籤
		searchTagAdd() {
			// console.log("searchTagAdd");
			const _this = this;

			_this.searchTag.isSearch = true;

			_this.searchConditions.series?.forEach((element) => {
				_this.allSearchConditions.series.forEach((element_series) => {
					if (element == String(element_series.value)) {
						if (_this.searchTag.series.indexOf(element_series.text) === -1) {
							_this.searchTag.series.push(element_series.text);
						}
					}
				});
			});

			_this.searchConditions.authtype?.forEach((element) => {
				if (element === "1") _this.searchTag.authtype.push("精選二手車");
				else if (element === "2") _this.searchTag.authtype.push("原廠認證中古車");
			});

			_this.searchConditions.model?.forEach((element) => {
				_this.allSearchConditions.model.forEach((element_model) => {
					if (element === element_model.value) {
						_this.searchTag.model.push(element_model.text);
					}
				});
			});

			if (_this.searchConditions.power?.length) {
				_this.searchConditions.power.forEach((element) => {
					_this.searchTag.power.push(element);
				});
			} else {
				_this.$set(_this.searchTag, "power", "");
			}

			_this.searchConditions.color?.forEach((element) => {
				_this.allSearchConditions.color.forEach((element_color) => {
					if (element === element_color.value) {
						_this.searchTag.color.push(element_color.text);
					}
				});
			});

			_this.searchConditions.dealer?.forEach((element) => {
				_this.allSearchConditions.dealer.forEach((element_dealer) => {
					if (element === element_dealer.value) {
						_this.searchTag.dealer.push(element_dealer.text);
					}
				});
			});

			if (_this.searchConditions.low_price) {
				_this.$set(
					_this.searchTag,
					"low_price",
					"最低價：" + _this.searchConditions.low_price + "萬",
				);
			} else {
				_this.$set(_this.searchTag, "low_price", "");
			}
			if (_this.searchConditions.high_price) {
				_this.$set(
					_this.searchTag,
					"high_price",
					"最高價：" + _this.searchConditions.high_price + "萬",
				);
			} else {
				_this.$set(_this.searchTag, "high_price", "");
			}

			if (_this.searchConditions.near_factory) {
				_this.$set(
					_this.searchTag,
					"near_factory",
					"出廠年份最近：" + _this.searchConditions.near_factory,
				);
			} else {
				_this.$set(_this.searchTag, "near_factory", "");
			}
			if (_this.searchConditions.far_factory) {
				_this.$set(
					_this.searchTag,
					"far_factory",
					"出廠年份最遠：" + _this.searchConditions.far_factory,
				);
			} else {
				_this.$set(_this.searchTag, "far_factory", "");
			}

			if (_this.searchConditions.low_mileage) {
				_this.$set(
					_this.searchTag,
					"low_mileage",
					"里程數最低：" +
						_this.changeToLocaleString(_this.searchConditions.low_mileage) +
						"km",
				);
			} else {
				_this.$set(_this.searchTag, "low_mileage", "");
			}
			if (_this.searchConditions.high_mileage) {
				_this.$set(
					_this.searchTag,
					"high_mileage",
					"里程數最高：" +
						_this.changeToLocaleString(_this.searchConditions.high_mileage) +
						"km",
				);
			} else {
				_this.$set(_this.searchTag, "high_mileage", "");
			}
		},
		//移除某一篩選條件
		removeConditions(target, index) {
			// console.log("removeConditions", target, index);

			const _this = this;
			if (index !== undefined) {
				_this.searchTag[target].splice(index, 1);
				_this.searchConditions[target].splice(index, 1);
			} else {
				_this.searchConditions[target] = "";
				_this.searchTag[target] = "";
			}
			_this.onConditionsChange();
		},
		//清除所有篩選條件
		resetConditions() {
			// console.log("resetConditions");
			const _this = this;

			_this.searchResult = [];

			_this.resetSearchConditions();

			_this.onConditionsChange();

			if (location.href.indexOf("?") !== -1) {
				_this.$router.replace("/");
			}
		},
		//重新賦值所有標籤
		resetSearchTag() {
			// console.log("resetSearchTag");
			const _this = this;

			_this.searchTag = JSON.parse(JSON.stringify(_this.defaultSearchTag));
		},
		//重新賦值所有已選擇之條件
		resetSearchConditions() {
			// console.log("resetSearchConditions");

			const _this = this;
			_this.searchConditions = JSON.parse(JSON.stringify(_this.defaultSearchConditions));
		},
		//更動搜尋條件時
		onConditionsChange() {
			// console.log("onConditionsChange");
			const _this = this;

			_this.searchResult = [];

			if (
				_this.searchConditions.low_price !== "" &&
				_this.searchConditions.high_price !== "" &&
				_this.searchConditions.low_price > _this.searchConditions.high_price
			) {
				let temp = _this.searchConditions.high_price;
				_this.searchConditions.high_price = _this.searchConditions.low_price;
				_this.searchConditions.low_price = temp;
			}

			if (
				_this.searchConditions.near_factory !== "" &&
				_this.searchConditions.far_factory !== "" &&
				_this.searchConditions.near_factory > _this.searchConditions.far_factory
			) {
				let temp = _this.searchConditions.far_factory;
				_this.searchConditions.far_factory = _this.searchConditions.near_factory;
				_this.searchConditions.near_factory = temp;
			}

			if (
				_this.searchConditions.low_mileage !== "" &&
				_this.searchConditions.high_mileage !== "" &&
				_this.searchConditions.low_mileage > _this.searchConditions.high_mileage
			) {
				let temp = _this.searchConditions.high_mileage;
				_this.searchConditions.high_mileage = _this.searchConditions.low_mileage;
				_this.searchConditions.low_mileage = temp;
			}

			const formData = new FormData();
			for (var key in _this.searchConditions) {
				formData.append(key, _this.searchConditions[key]);
			}

			// 當選取經銷商時更動網址
			let dealerArr = _this.searchConditions.dealer;
			let aliasArr = [];

			for (let i = 0; i < dealerArr.length; i++) {
				for (let j = 0; j < _this.allSearchConditions.dealer.length; j++) {
					if (_this.allSearchConditions.dealer[j].value === dealerArr[i]) {
						aliasArr.push(_this.allSearchConditions.dealer[j].alias);
					}
				}
			}
			let alias = "";

			for (let i = 0; i < aliasArr.length; i++) {
				alias += `${aliasArr[i]},`;
			}
			if (alias !== "") {
				_this.$router.replace(`?dealer=${alias.replace(/,$/, "")}`).catch((err) => {
					console.log(err);
					// 如果是 NavigationDuplicated，就不做任何處理
					if (err.name !== "NavigationDuplicated") {
						throw err;
					}
				});
			} else if (alias === "" && location.href.indexOf("?") !== -1) {
				_this.$router.replace("/");
			}

			_this.searchInit(formData);
		},
		//更動排序方式
		onsortChange() {
			// console.log("onsortChange");
			const _this = this;

			switch (_this.sortValue) {
				case "": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						return b.id < a.id ? 1 : -1;
					});
					break;
				}
				case "new": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						return b.id > a.id ? 1 : -1;
					});
					break;
				}
				case "priceHigh": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						return b.price < a.price ? 1 : -1;
					});
					break;
				}
				case "priceLow": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						return b.price > a.price ? 1 : -1;
					});
					break;
				}
				case "mileageHigh": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						return b.mileage < a.mileage ? 1 : -1;
					});
					break;
				}
				case "mileageLow": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						return b.mileage > a.mileage ? 1 : -1;
					});
					break;
				}
				case "facHigh": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						if (b.fac_year > a.fac_year) return 1;
						if (b.fac_year < a.fac_year) return -1;
						if (b.fac_month > a.fac_month) return 1;
						if (b.fac_month < a.fac_month) return -1;
					});
					break;
				}
				case "facLow": {
					_this.searchResult = _this.searchResult.sort((a, b) => {
						if (b.fac_year < a.fac_year) return 1;
						if (b.fac_year > a.fac_year) return -1;
						if (b.fac_month < a.fac_month) return 1;
						if (b.fac_month > a.fac_month) return -1;
					});
					break;
				}
			}

			let arr = [];
			_this.searchResult.forEach((element, index) => {
				if (element.status_name === "銷售中" || element.status_name === "促銷中") {
					arr.push(element);
				}
				if (index == _this.searchResult.length - 1) {
					_this.searchResult.forEach((element) => {
						if (element.status_name === "已預訂") {
							arr.push(element);
						}
					});
				}
			});
			_this.searchResult = arr;
		},
		changeToLocaleString(str) {
			// console.log("changeToLocaleString", str);
			str = parseInt(str);
			return str.toLocaleString();
		},
		assistantToggle() {
			// console.log("assistantToggle");
			const _this = this;
			_this.isActiveAssistant = true;
		},
		tagBoxToggle() {
			// console.log("tagBoxToggle");
			const _this = this;
			_this.isShowTag = !_this.isShowTag;
		},
		conditionToggle() {
			// console.log("conditionToggle");
			const _this = this;
			_this.isActiveCondition = !_this.isActiveCondition;

			arphicWebFontApi.loadWebFont([
				{
					selectorName: ".font", // 指定元素
					fontName: "文鼎標準宋體_B", // 設定中文字型名稱
				},
			]);
		},
		conditionOpen(target) {
			// console.log("conditionOpen",target)
			const _this = this;
			_this.$set(_this.isActiveConditionOpen, target, !_this.isActiveConditionOpen[target]);
		},
		trackingToggle(target, id) {
			// console.log("trackingToggle");
			const _this = this;
			switch (target) {
				case "詳細資訊": {
					gtag("event", "conversion", {
						send_to: "AW-16542457053/02NQCJaIwtQaEN25h9A9",
					});

					fbq("track", "ViewContent");
					_this.$router.push(`/info/${id}`);
					break;
				}
			}
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>

<style src="./style.sass" lang="sass" scoped>
@use "@/assets/sass/_variable.sass"
@use "@/assets/sass/_mixin.sass"
</style>
